import HeadsetLargeIcon from '../../assets/icons/headset-large.svg?react';
import { FC, useState } from 'react';

import { SupportModal } from '../organisms/SupportModal';

type SupportHintProps = {
  className?: string;
};

export const SupportHint: FC<SupportHintProps> = ({ className = '' }) => {
  const [isSupportModalOpen, setIsSupportModalOpen] = useState(false);

  return (
    <div
      className={`flex items-center justify-center gap-[20px] rounded-[16px] bg-[#f1f7fa] p-[16px] ${className}`}
    >
      <div className="flex size-[48px] items-center gap-3 rounded-[100px] bg-[#0788F1]/10 p-[16px]">
        <HeadsetLargeIcon className="size-[32px] stroke-2" />
      </div>
      <p className="flex-1 text-sm leading-[18px] text-transparent">
        <span className="text-[#151515]">
          Если вам сложно заполнить анкету или вы не знаете, как ответить на
          некоторые вопросы — обратитесь в нашу{' '}
        </span>
        <button
          type="button"
          onClick={() => setIsSupportModalOpen(true)}
          className="text-[#0788f1] underline-offset-2 hover:underline"
        >
          поддержку
        </button>
        <span className="text-[#151515]">, мы поможем.</span>
      </p>
      <SupportModal
        isOpen={isSupportModalOpen}
        onClose={() => setIsSupportModalOpen(false)}
      />
    </div>
  );
};
